import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import CheckCircle from '@material-ui/icons/CheckCircle';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import AttachMoney from '@material-ui/icons/AttachMoney';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import DriverCar from '../../assets/img/driver_car.png';
import WalletDriver from '../../assets/img/motorista_carteira.png';

const useStyles = makeStyles(styles);

export default function ProductDriverSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>Seja parte desse Time!</h2>
          <br/>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Lucre Mais"
              description="Trabalhe conosco e faça parte de uma equipe que cresce junto com a gente, receba 100% das corridas em dinheiro ou na sua máquina de cartão própria."
              icon={AttachMoney}
              iconColor="success"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Atendimento de qualidade, em qualquer lugar, onde precisar."
              description="Tenha a segurança de ser atendido, sempre que precisar, suporte especializado em lhe assistir da melhor forma possível!"
              icon={ContactSupportIcon}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Segurança"
              description="O primeiro app da categoria a exigir Reconhecimento Facial dos passageiros. Nosso avançado serviço de reconhecimento facial do passageiro irá lhe acompanhar sempre que necessário, as poderosas máquinas da Microsoft podem indentificar em segundos algum risco próximo à você."
              icon={VerifiedUser}
              iconColor="success"
              vertical
              facial
            />
          </GridItem>
        </GridContainer>
      </div>
      <div style={{display: 'flex', flexDirection: 'column', marginRight: 20, marginLeft: 'auto'}}>
        <br/>
        <h3 className={classes.title}>Como faço para dirigir com o Tac ?</h3>
        <img src={DriverCar} style={{alignSelf:'flex-start', backgroundSize: 'cover', width:'100%' }} />
        <ListItem>
          <ListItemIcon>
            <CheckCircle style={{ color: '#48A54B' }} />
          </ListItemIcon>
          <ListItemText primary='CNH com a observação "EAR"' style={{ color: '#616A8F' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckCircle style={{ color: '#48A54B' }} />
          </ListItemIcon>
          <ListItemText primary='CRLV' style={{ color: '#616A8F' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckCircle style={{ color: '#48A54B' }} />
          </ListItemIcon>
          <ListItemText primary='Não possuir Antecedentes Criminais' style={{ color: '#616A8F' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckCircle style={{ color: '#48A54B' }} />
          </ListItemIcon>
          <ListItemText primary='Veículos com até 8 anos de fabricação ou conforme regulamentação do município' style={{ color: '#616A8F' }} />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <CheckCircle style={{ color: '#48A54B' }} />
          </ListItemIcon>
          <ListItemText primary='Cumprir qualquer outro requisito estabelecido pelo Poder Público competente' style={{ color: '#616A8F' }} />
        </ListItem>
      </div>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h3 className={classes.title}>Para ser motorista basta fazer um cadastro pelo app.</h3>
          <br/>
          <h5 className={classes.description}>Aguardar aprovação.</h5>
          <h5 className={classes.description}>
          Após aprovado você tem 30 dias gratuitos para conhecer a plataforma.
          </h5>
          <h5 className={classes.description}>
          Após os 30 dias se quiser continuar trabalhando com nosso aplicativo basta pagar a taxa de R$ 100,00 fixo por mês.
          </h5>
          <h5 className={classes.description}>
          O motorista recebe 100% das corridas recebidas em dinheiro ou na maquininha de cartão própria do motorista. As corridas pagas com cartão pelo App ou crédito da carteira do app será cobrada 7% de taxas de administração. 
          </h5>
          <h4 className={classes.description}>Ou seja o motorista recebe 93% do valor da corrida.</h4>
          <h5 className={classes.description}>
          Ex: uma corrida de R$ 10,00 paga em dinheiro ou na maquininha do motorista, o motorista fica com os R$ 10,00 livre para ele.
          </h5>
          <h5 className={classes.description}>
          Uma corrida de R$ 10,00 paga dentro do aplicativo o motorista receberá R$ 9,30 através de ted bancário todo final de mês.
          </h5>
          <h3 className={classes.title}>Escolha receber mais e acompanhe seus ganhos no app</h3>
          <img src={WalletDriver} style={{alignSelf:'center', backgroundSize: 'cover', width:'100%' }} />
          <h3 className={classes.title}>Tac</h3>
          <br/>
        </GridItem>
      </GridContainer>
    </div>
  );
}
